/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import NewsletterModel from 'cio/models/newsletter';
import AlertsService from 'cio/services/alerts';

type NewsletterStopSendingModalArgs = {
  newsletter: NewsletterModel;
  onClose: () => unknown;
};

export default class NewsletterStopSendingModal extends Component<NewsletterStopSendingModalArgs> {
  @service alerts!: AlertsService;

  get isChannelInApp(): boolean {
    return this.args.newsletter.channel === 'in_app';
  }

  stopSendingTask = task(async () => {
    this.args.newsletter.set('updateType', 'cancel');

    try {
      await this.args.newsletter.save();
      this.alerts.success('newsletter.stopSending', 'Sending stopped');
    } catch (e) {
      this.args.newsletter.rollbackAttributes();
      this.alerts.error(
        'newsletter.stopSending',
        'Problem stopping newsletter send. Please try again or contact support for help.',
      );
    } finally {
      this.args.onClose();
    }
  });
}
